import { motion } from "framer-motion";

// Subtle, tasteful entrance used across sections. Respects reduced motion via
// the global CSS rule in App.css.
export const SectionReveal = ({
  children,
  className = "",
  delay = 0,
  y = 12,
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.45, ease: "easeOut", delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
